import React from "react";

import { P, SectionHeading, SectionMainWrapper, SectionSmallHeading, SectionSubHeading, SectionWrapper, Text } from "../../Styles/style";

import uniswap from "../../../assets/images/twitter.png"
import dextools from "../../../assets/images/telegram.png"
import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";
import arbvideo from "../../../assets/images/mainanim.png"

const VideoBK = styled.img`
  width: 100%;
  height: auto;
  max-width: 570px;
`;
const GridHEading = styled(Grid)`
padding: 50px 0;
display: flex;
align-items: center;
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridVideo = styled(Grid)`
mix-blend-mode: lighten;
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-right: 10px;
  @media screen and (max-width:599px){
   max-width: ${(props) => (props.mw ? props.mw : "100PX")};

 }
`
const Arbspoan = styled.span`
 color: ${(props) => props.theme.textTertiary};
  font-size: ${(props) => props.fs ? props.fs : "calc(45px + (26 - 22) * ((100vw - 146px) / (1600 - 250)))"};
font-family: "P-R";
  width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  padding: ${(props) => (props.p ? props.p : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  font-weight: 200;
  margin: ${(props) => (props.m ? props.m : "")};

  @media screen and (max-width: 972px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 20) * ((100vw - 16px) / (1600 - 250)))"};
  }
  @media screen and (max-width: 419px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 10) * ((100vw - 26px) / (1600 - 250)))"};
  }
`
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 8px;
padding: 8px 40px;
font-family:'P-B';
margin-right: 15px;
@media screen and (max-width:399px){
  padding: 8px 20px;

}

`
const Section1_Header = () => {
  const theme = useTheme()
  return (
    <SectionMainWrapper p="0rem 0" id="home">
      <Container maxWidth="xl">

        <GridHEading container >

          <GridImage xs={12} md={6}>
            <SectionSubHeading p="0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-duration="600"
                data-aos-offset="0" m="0">Pulse Pepe</SectionSubHeading>
            <SectionHeading
            mw="67%"
              p="0px 0 20px"
              m="0"
              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              the most memeable
              memecoin on pulsechain.
            </SectionHeading>
            <P
              maxWidth="80%"
              p="0 0 20px 0"
              m="0"

              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              The dogs have had their day, it’s time for Pepe to take reign. Get in on the Pepe craze with Pulse Pepe on the super fast Pulse Chain!
            </P>
            <div data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-duration="500"
              data-aos-offset="0"
            >

              <BuyNow
                href="https://app.pulsex.com/swap?outputCurrency=0x64d3799fe6E5e833996752c252A141F2Cfe7EaA9"
                target="_blank">
                Buy Now
              </BuyNow>
              <BuyNow bgColor="#8204F0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href="https://dexscreener.com/pulsechain/0x1c50dfd4533a0ade52b8d21c0718d120a0b63b7b"
                target="_blank">
                View Chart
              </BuyNow>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <SectionSmallHeading p="40px 0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="800"
                data-aos-duration="400"
                data-aos-offset="0">Follow us:</SectionSmallHeading>
              <a href="https://twitter.com/pulsepepecoin"  target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1100"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={uniswap} />
              </a>
              <a href="https://t.me/pulsepepejoin" target="blank" data-aos="zoom-in-up"
                data-aos-easing="ease-in"
                data-aos-delay="1200"
                data-aos-duration="500"
                data-aos-offset="0">
                <JOiningLinks src={dextools} />
              </a>
            </div>
          </GridImage>
          <GridVideo
            xs={12}
            md={6}
            data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK src={arbvideo} />
          </GridVideo>
        </GridHEading>
      </Container>
    </SectionMainWrapper>
  );
};

export default Section1_Header;
